import apiClient from "./client";

export const activeRoute = {
  getByToken: () => apiClient.get("/active-route"),
};
